import { LengthUnits } from '../enums';
import { lengthUnitFactors } from '../contants';

export function convertDistance(value: number, base: LengthUnits, target: LengthUnits): number {
  const factor = lengthUnitFactors[base][target];
  if (factor) {
    return value * factor;
  }

  throw new Error(`No factor for ${base} and ${target}`);
}
